<script setup lang="ts">
import { supabase } from '@/composables/supabaseClient'
import toastThrowError from '@/helpers/toastThrowError'
import uuidv7 from '@/helpers/uuidv7'
import { useDatabaseStore } from '@/stores/databaseStore'
import { ref } from 'vue'
import BaseButton from './BaseButton.vue'
import BaseInput from './BaseInput.vue'

const databaseStore = useDatabaseStore()

const newSourceName = ref('')

async function saveNewSource() {
  const result = await supabase
    .from('cost_source')
    .insert({ id: uuidv7(), name: newSourceName.value })
    .select()
    .single()
  if (result.error) throw toastThrowError('Unable to add cost source', result.error)
  databaseStore.costSources?.push(result.data)
  newSourceName.value = ''
}
</script>

<template>
  <div class="flex h-full w-full flex-col gap-3 p-3">
    <span class="font-bold">Cost Sources</span>
    <div
      v-for="costSource in databaseStore.costSources"
      :key="costSource.id"
      class="rounded border border-gray-300 p-2.5"
    >
      {{ costSource.name }}
    </div>
    <BaseInput v-model="newSourceName" class="w-full border p-1" placeholder="New Cost Source..." />
    <BaseButton @click="saveNewSource()">Save</BaseButton>
  </div>
</template>
